/* eslint-disable max-len */
import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const ScatterChartIcon: FC<IconProps> = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 5C4.55228 5 5 5.44772 5 6V25H28C28.5523 25 29 25.4477 29 26C29 26.5523 28.5523 27 28 27H4C3.96539 27 3.93116 26.9985 3.89746 26.9951C3.39333 26.9438 3 26.5177 3 26V6C3 5.44772 3.44772 5 4 5Z"
      />
      <path
        d="M9.5 19C10.3284 19 11 19.6716 11 20.5C11 21.3284 10.3284 22 9.5 22C8.67157 22 8 21.3284 8 20.5C8 19.6716 8.67157 19 9.5 19Z"
      />
      <path
        d="M23.5 19C24.3284 19 25 19.6716 25 20.5C25 21.3284 24.3284 22 23.5 22C22.6716 22 22 21.3284 22 20.5C22 19.6716 22.6716 19 23.5 19Z"
      />
      <path
        d="M16.5 17C17.3284 17 18 17.6716 18 18.5C18 19.3284 17.3284 20 16.5 20C15.6716 20 15 19.3284 15 18.5C15 17.6716 15.6716 17 16.5 17Z"
      />
      <path
        d="M21.5 13C22.3284 13 23 13.6716 23 14.5C23 15.3284 22.3284 16 21.5 16C20.6716 16 20 15.3284 20 14.5C20 13.6716 20.6716 13 21.5 13Z"
      />
      <path
        d="M13.5 10C14.3284 10 15 10.6716 15 11.5C15 12.3284 14.3284 13 13.5 13C12.6716 13 12 12.3284 12 11.5C12 10.6716 12.6716 10 13.5 10Z"
      />
      <path
        d="M24.5 8C25.3284 8 26 8.67157 26 9.5C26 10.3284 25.3284 11 24.5 11C23.6716 11 23 10.3284 23 9.5C23 8.67157 23.6716 8 24.5 8Z"
      />
    </BaseIcon>
  );
};

